import { View, Text } from "@react-pdf/renderer";
import styles from "../../css";

export const TrainingDetails = ({ profile }) => {
  return (
    <View style={styles.report_container}>
      <View style={styles.big_header}>
        <Text>Recommended Training</Text>
      </View>
      <View style={styles.text_box}>
        <Text style={styles.text_description}>
          This section illustrates the cybersecurity competencies level that
          have been assessed. Each box represents one competency and the needed
          areas of improvements in Knowledge, Skills or Abilities.
        </Text>
      </View>

      {profile["employee fcourse"]["fcourse 1"] !== "-" && (
        <View wrap={false}>
          <View style={styles.small_header}>
            <Text>Foundation Level</Text>
          </View>
          <View style={styles.training_table_heading}>
            <View style={styles.training_table_heading_left}>
              <Text>Course Name</Text>
            </View>
            <View style={styles.training_table_heading_right}>
              <Text>Type</Text>
            </View>
          </View>
          <View style={styles.training_details}>
            {profile["employee fcourse"]["fcourse 1"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee fcourse"]["fcourse 1"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee fcourse"]["fcourse type 1"]}
                </Text>
              </View>
            )}
            {profile["employee fcourse"]["fcourse 2"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee fcourse"]["fcourse 2"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee fcourse"]["fcourse type 2"]}
                </Text>
              </View>
            )}

            {profile["employee fcourse"]["fcourse 3"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee fcourse"]["fcourse 3"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee fcourse"]["fcourse type 3"]}
                </Text>
              </View>
            )}

            {profile["employee fcourse"]["fcourse 4"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee fcourse"]["fcourse 4"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee fcourse"]["fcourse type 4"]}
                </Text>
              </View>
            )}

            {profile["employee fcourse"]["fcourse 5"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee fcourse"]["fcourse 5"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee fcourse"]["fcourse type 5"]}
                </Text>
              </View>
            )}

            {profile["employee fcourse"]["fcourse 6"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee fcourse"]["fcourse 6"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee fcourse"]["fcourse type 6"]}
                </Text>
              </View>
            )}

            {profile["employee fcourse"]["fcourse 7"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee fcourse"]["fcourse 7"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee fcourse"]["fcourse type 7"]}
                </Text>
              </View>
            )}

            {profile["employee fcourse"]["fcourse 8"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee fcourse"]["fcourse 8"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee fcourse"]["fcourse type 8"]}
                </Text>
              </View>
            )}

            {profile["employee fcourse"]["fcourse 9"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee fcourse"]["fcourse 9"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee fcourse"]["fcourse type 9"]}
                </Text>
              </View>
            )}

            <View style={styles.training_table_row}></View>
          </View>
        </View>
      )}

      {profile["employee ccourse"]["ccourse 1"] !== "-" && (
        <View wrap={false}>
          <View style={styles.small_header}>
            <Text>Core Level</Text>
          </View>
          <View style={styles.training_table_heading}>
            <View style={styles.training_table_heading_left}>
              <Text>Course Name</Text>
            </View>
            <View style={styles.training_table_heading_right}>
              <Text>Type</Text>
            </View>
          </View>
          <View style={styles.training_details} wrap={false}>
            {profile["employee ccourse"]["ccourse 1"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee ccourse"]["ccourse 1"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee ccourse"]["ccourse type 1"]}
                </Text>
              </View>
            )}
            {profile["employee ccourse"]["ccourse 2"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee ccourse"]["ccourse 2"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee ccourse"]["ccourse type 2"]}
                </Text>
              </View>
            )}
            {profile["employee ccourse"]["ccourse 3"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee ccourse"]["ccourse 3"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee ccourse"]["ccourse type 3"]}
                </Text>
              </View>
            )}
            {profile["employee ccourse"]["ccourse 4"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee ccourse"]["ccourse 4"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee ccourse"]["ccourse type 4"]}
                </Text>
              </View>
            )}
            {profile["employee ccourse"]["ccourse 5"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee ccourse"]["ccourse 5"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee ccourse"]["ccourse type 5"]}
                </Text>
              </View>
            )}
            {profile["employee ccourse"]["ccourse 6"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee ccourse"]["ccourse 6"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee ccourse"]["ccourse type 6"]}
                </Text>
              </View>
            )}

            <View style={styles.training_table_row}></View>
          </View>
        </View>
      )}

      {profile["employee acourse"]["acourse 1"] !== "-" && (
        <View wrap={false}>
          <View style={styles.small_header}>
            <Text>Advanced Level</Text>
          </View>
          <View style={styles.training_table_heading}>
            <View style={styles.training_table_heading_left}>
              <Text>Course Name</Text>
            </View>
            <View style={styles.training_table_heading_right}>
              <Text>Type</Text>
            </View>
          </View>
          <View style={styles.training_details} wrap={false}>
            {profile["employee acourse"]["acourse 1"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee acourse"]["acourse 1"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee acourse"]["acourse type 1"]}
                </Text>
              </View>
            )}
            {profile["employee acourse"]["acourse 2"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee acourse"]["acourse 2"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee acourse"]["acourse type 2"]}
                </Text>
              </View>
            )}
            {profile["employee acourse"]["acourse 3"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee acourse"]["acourse 3"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee acourse"]["acourse type 3"]}
                </Text>
              </View>
            )}
            {profile["employee acourse"]["acourse 4"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee acourse"]["acourse 4"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee acourse"]["acourse type 4"]}
                </Text>
              </View>
            )}
            {profile["employee acourse"]["acourse 5"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee acourse"]["acourse 5"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee acourse"]["acourse type 5"]}
                </Text>
              </View>
            )}
            {profile["employee acourse"]["acourse 6"] !== "-" && (
              <View style={styles.training_table_row}>
                <Text style={styles.training_table_left}>
                  {profile["employee acourse"]["acourse 6"]}
                </Text>
                <Text style={styles.training_table_right}>
                  {profile["employee acourse"]["acourse type 6"]}
                </Text>
              </View>
            )}
            <View style={styles.training_table_row}></View>
          </View>
        </View>
      )}
    </View>
  );
};

const ReportTraining = ({ userProfile }) => {
  return (
    <View>
      <TrainingDetails profile={userProfile} />
    </View>
  );
};

export default ReportTraining;
